import { aboutButtons, aboutMariaText } from "i18n/about";
import {
  ClientandPartnerButton,
  ClientandPartnerText,
  ClientDirectoryData,
} from "i18n/client";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MainClient = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = ClientandPartnerText[lang];
  const btn = ClientandPartnerButton[lang];

  const navigate = useNavigate();

  const directory = ClientDirectoryData[lang];

  const [selectedCategory, setSelectedCategory] = useState(
    directory.categories[0],
  );

  const filteredClients =
    selectedCategory === directory.categories[0]
      ? directory.clients
      : directory.clients.filter((c) => c.category === selectedCategory);

  return (
    <section className="max-w-8xl mx-auto px-6 pt-12  bg-[#f5f5f3]">
      <div className="max-w-7xl mx-auto text-[#111] px-0 ">
        <div className="text-center my-14">
          <p className="uppercase tracking-[0.3em] text-xs text-[#9B6B53] mb-3">
            {lang === "vi" ? "Mạng lưới khách hàng" : "Client Network"}
          </p>

          <h2 className="font-[Crimson] text-4xl md:text-5xl text-reddark">
            {t.title}
          </h2>
          <div className="w-24 h-[2px] bg-reddark mx-auto mt-8 mb-8" />
        </div>

        {/* Intro */}
        <div className="space-y-8 text-base md:text-lg leading-relaxed mb-8">
          {t.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          {t.body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>

      <div
        className="
      border-0 border-[#E8DED5]
      rounded-[32px]
      max-w-7xl mx-auto  py-12 
    "
      >
        {" "}
        {/* Filters */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 mb-10">
          {directory.categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`
        w-full
        px-4 py-3
        rounded-2xl
        text-sm font-medium
        text-center
        transition-all duration-300
        ${
          selectedCategory === category
            ? "bg-reddark text-white shadow-md"
            : "bg-[#F7F4F1] text-gray-700 border border-[#E8DED5] hover:border-reddark"
        }
      `}
            >
              {category}
            </button>
          ))}
        </div>
        {/* Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-5">
          {filteredClients.map((client, index) => (
            <div
              key={index}
              className="
        group relative overflow-hidden
        rounded-2xl md:rounded-3xl
        border border-[#E8DED5]
        bg-white
        p-3 md:p-5
        transition-all duration-300
        hover:-translate-y-1
        hover:shadow-lg
      "
            >
              <div
                className="
          absolute top-0 left-0
          h-1 w-full
          bg-gradient-to-r
          from-reddark via-[#C98B65] to-reddark
          scale-x-0 origin-left
          transition-transform duration-500
          group-hover:scale-x-100
        "
              />

              <div className="flex items-center gap-3">
                {/* Avatar */}
                <div
                  className="
            w-10 h-10 md:w-14 md:h-14
            rounded-xl md:rounded-2xl
            bg-reddark/10
            text-reddark
            flex items-center justify-center
            font-bold
            text-sm md:text-xl
            shrink-0
          "
                >
                  {client.name.charAt(0)}
                </div>

                {/* Content */}
                <div className="min-w-0 flex-1">
                  <h3
                    className="
              font-semibold
              text-xs md:text-base
              text-[#111]
              truncate
            "
                  >
                    {client.name}
                  </h3>

                  <p
                    className="
              text-[11px] md:text-sm
              text-[#9B6B53]
              truncate
            "
                  >
                    {client.category}
                  </p>

                  <p
                    className="
              text-[10px] md:text-xs
              text-gray-500
              truncate
            "
                  >
                    {client.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainClient;
